import styled from 'styled-components';
import { StyledSegmentedControl } from '../../../../../CommonComponents/OPL/SegmentedControl/SegmentedControl.styles';
import { Card } from '../../../../../CommonComponents/OPL/Card/Card';

export const StyledCard = styled(Card)({
  padding: 16,

  [`> ${Text}`]: {
    display: 'block',
  },

  [StyledSegmentedControl]: {
    display: 'none',
  },
});
